import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ActionHelper,
  OnyxIconButtonComponent,
  OnyxInformationHeadingComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
  OnyxNamePipe,
  OnyxPhonePipe,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import type { Contractor } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-contacts',
  imports: [
    OnyxInformationRowComponent,
    OnyxIconButtonComponent,
    OnyxPhonePipe,
    TranslatePipe,
    OnyxNamePipe,
    OnyxInformationHeadingComponent,
    OnyxInformationListComponent,
  ],
  templateUrl: './contractor-contacts.component.html',
  styleUrl: './contractor-contacts.component.scss',
})
export class ContractorContactsComponent {
  public readonly contractor = input.required<Contractor>();

  protected readonly ActionHelper = ActionHelper;
  protected readonly DictionaryCode = DictionaryCode;
}
